module.exports = __webpack_public_path__ + "static/media/check-icon.d9f2a8c8.svg";